import { Helpers } from '../../helpers';
import { IRigCostType } from '../../interfaces/irig-cost-type';
import { RigCost } from '../rig-cost';

export class RigCostTypeBase {
  RigCostTypeId: number;
  Description: string;
  SortOrder: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  RigCosts_RigCostType?: Array<RigCost> | null;

  constructor(item?: IRigCostType) {
    if (item) {

      this.RigCostTypeId = item.RigCostTypeId;
      this.Description = item.Description;
      this.SortOrder = item.SortOrder;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.RigCosts_RigCostType = Helpers.createClassArray(RigCost, item.RigCosts_RigCostType);
    }
  }
}